import React from 'react';

import { EditProfile } from './EditProfile';

import { Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';

import { dateTimeConstants } from '_constants';
import moment from 'moment';
import { formatDate } from '_helpers/helpers';

const QualificationsComponent = ({
  profileData,
  dropdownData,
  refetchUser,
  isOpen,
  toggleAccordion,
  changeTab,
  permList,
  authUser,
}) => {
  return (
    <div
      id="qualifications"
      className={`profile-data__drops profile-data_comp ${isOpen ? 'is-active' : ''}`}
    >
      <header onClick={() => toggleAccordion('#qualifications')}>
        <button type="button">
          <h3>Qualifications</h3>
        </button>
      </header>
      <div className="profile-data__drops-cnt">
        <ul role="list">
          <li role="listitem">
            <span>
              <b>Tree Care Apprentice</b>
            </span>
            <span>
              {(profileData.tca ? 'Qualified' : 'Not Qualified') +
                (profileData.tca && profileData.tca_date
                  ? ' on ' + formatDate(profileData.tca_date)
                  : '')}
            </span>
            <EditProfile
              label="Tree Care Apprentice"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('tca', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.tca}
                    className={errors.tca && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.tca && (
                    <p className="error-message">{errors.tca.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="tca_date"
                    control={control}
                    defaultValue={
                      profileData.tca_date
                        ? moment(profileData.tca_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.tca_date && (
                    <p className="error-message">{errors.tca_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Basic Training for Ground Ops</b>
            </span>
            <span>
              {(profileData.btgo ? 'Qualified' : 'Not Qualified') +
                (profileData.btgo && profileData.btgo_date
                  ? ' on ' + formatDate(profileData.btgo_date)
                  : '')}
            </span>
            <EditProfile
              label="Basic Training for Ground Ops"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('btgo', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.btgo}
                    className={errors.btgo && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.btgo && (
                    <p className="error-message">{errors.btgo.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="btgo_date"
                    control={control}
                    defaultValue={
                      profileData.btgo_date
                        ? moment(profileData.btgo_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.btgo_date && (
                    <p className="error-message">{errors.btgo_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Ground Operations Specialist</b>
            </span>
            <span>
              {(profileData.gos ? 'Qualified' : 'Not Qualified') +
                (profileData.gos && profileData.gos_date
                  ? ' on ' + formatDate(profileData.gos_date)
                  : '')}
            </span>
            <EditProfile
              label="Ground Operations Specialist"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('gos', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.gos}
                    className={errors.gos && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.gos && (
                    <p className="error-message">{errors.gos.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="gos_date"
                    control={control}
                    defaultValue={
                      profileData.gos_date
                        ? moment(profileData.gos_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.gos_date && (
                    <p className="error-message">{errors.gos_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Chipper Operator Specialist</b>
            </span>
            <span>
              {(profileData.cos ? 'Qualified' : 'Not Qualified') +
                (profileData.cos && profileData.cos_date
                  ? ' on ' + formatDate(profileData.cos_date)
                  : '')}
            </span>
            <EditProfile
              label="Chipper Operator Specialist"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('cos', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.cos}
                    className={errors.cos && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.cos && (
                    <p className="error-message">{errors.cos.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="cos_date"
                    control={control}
                    defaultValue={
                      profileData.cos_date
                        ? moment(profileData.cos_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.cos_date && (
                    <p className="error-message">{errors.cos_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Chainsaw Specialist</b>
            </span>
            <span>
              {(profileData.cs ? 'Qualified' : 'Not Qualified') +
                (profileData.cs && profileData.cs_date
                  ? ' on ' + formatDate(profileData.cs_date)
                  : '')}
            </span>
            <EditProfile
              label="Chainsaw Specialist"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('cs', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.cs}
                    className={errors.cs && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.cs && (
                    <p className="error-message">{errors.cs.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="cs_date"
                    control={control}
                    defaultValue={
                      profileData.cs_date
                        ? moment(profileData.cs_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.cs_date && (
                    <p className="error-message">{errors.cs_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Driver Class C</b>
            </span>
            <span>
              {(profileData.dlc ? 'Qualified' : 'Not Qualified') +
                (profileData.dlc && profileData.dlc_date
                  ? ' on ' + formatDate(profileData.dlc_date)
                  : '')}
            </span>
            <EditProfile
              label="Driver Class C"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('dlc', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.dlc}
                    className={errors.dlc && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.dlc && (
                    <p className="error-message">{errors.dlc.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="dlc_date"
                    control={control}
                    defaultValue={
                      profileData.dlc_date
                        ? moment(profileData.dlc_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.dlc_date && (
                    <p className="error-message">{errors.dlc_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Crew Leader</b>
            </span>
            <span>
              {(profileData.cl ? 'Qualified' : 'Not Qualified') +
                (profileData.cl && profileData.cl_date
                  ? ' on ' + formatDate(profileData.cl_date)
                  : '')}
            </span>
            <EditProfile
              label="Crew Leader"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('cl', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.cl}
                    className={errors.cl && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.cl && (
                    <p className="error-message">{errors.cl.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="cl_date"
                    control={control}
                    defaultValue={
                      profileData.cl_date
                        ? moment(profileData.cl_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.cl_date && (
                    <p className="error-message">{errors.cl_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Stump Grinding Operations</b>
            </span>
            <span>
              {(profileData.sgo ? 'Qualified' : 'Not Qualified') +
                (profileData.sgo && profileData.sgo_date
                  ? ' on ' + formatDate(profileData.sgo_date)
                  : '')}
            </span>
            <EditProfile
              label="Stump Grinding Operations"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('sgo', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.sgo}
                    className={errors.sgo && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.sgo && (
                    <p className="error-message">{errors.sgo.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="sgo_date"
                    control={control}
                    defaultValue={
                      profileData.sgo_date
                        ? moment(profileData.sgo_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.sgo_date && (
                    <p className="error-message">{errors.sgo_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Commercial Driver (A,B)</b>
            </span>
            <span>
              {(profileData.cdl ? 'Qualified' : 'Not Qualified') +
                (profileData.cdl && profileData.cdl_date
                  ? ' on ' + formatDate(profileData.cdl_date)
                  : '')}
            </span>
            <EditProfile
              label="Commercial Driver (A,B)"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('cdl', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.cdl}
                    className={errors.cdl && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.cdl && (
                    <p className="error-message">{errors.cdl.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="cdl_date"
                    control={control}
                    defaultValue={
                      profileData.cdl_date
                        ? moment(profileData.cdl_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.cdl_date && (
                    <p className="error-message">{errors.cdl_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Electrical Hazard Awareness (EHAP)</b>
            </span>
            <span>
              {(profileData.ehap ? 'Qualified' : 'Not Qualified') +
                (profileData.ehap && profileData.ehap_date
                  ? ' on ' + formatDate(profileData.ehap_date)
                  : '')}
            </span>
            <EditProfile
              label="Electrical Hazard Awareness (EHAP)"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('ehap', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.ehap}
                    className={errors.ehap && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.ehap && (
                    <p className="error-message">{errors.ehap.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="ehap_date"
                    control={control}
                    defaultValue={
                      profileData.ehap_date
                        ? moment(profileData.ehap_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.ehap_date && (
                    <p className="error-message">{errors.ehap_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Basic Training for Tree Climbers</b>
            </span>
            <span>
              {(profileData.bttc ? 'Qualified' : 'Not Qualified') +
                (profileData.bttc && profileData.bttc_date
                  ? ' on ' + formatDate(profileData.bttc_date)
                  : '')}
            </span>
            <EditProfile
              label="Basic Training for Tree Climbers"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('bttc', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.bttc}
                    className={errors.bttc && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.bttc && (
                    <p className="error-message">{errors.bttc.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="bttc_date"
                    control={control}
                    defaultValue={
                      profileData.bttc_date
                        ? moment(profileData.bttc_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.bttc_date && (
                    <p className="error-message">{errors.bttc_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Tree care Safety Specialist</b>
            </span>
            <span>
              {(profileData.tcss ? 'Qualified' : 'Not Qualified') +
                (profileData.tcss && profileData.tcss_date
                  ? ' on ' + formatDate(profileData.tcss_date)
                  : '')}
            </span>
            <EditProfile
              label="Tree care Safety Specialist"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('tcss', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.tcss}
                    className={errors.tcss && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.tcss && (
                    <p className="error-message">{errors.tcss.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="tcss_date"
                    control={control}
                    defaultValue={
                      profileData.tcss_date
                        ? moment(profileData.tcss_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.tcss_date && (
                    <p className="error-message">{errors.tcss_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Tree Climber Specialist</b>
            </span>
            <span>
              {(profileData.tcs ? 'Qualified' : 'Not Qualified') +
                (profileData.tcs && profileData.tcs_date
                  ? ' on ' + formatDate(profileData.tcs_date)
                  : '')}
            </span>
            <EditProfile
              label="Tree Climber Specialist"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('tcs', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.tcs}
                    className={errors.tcs && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.tcs && (
                    <p className="error-message">{errors.tcs.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="tcs_date"
                    control={control}
                    defaultValue={
                      profileData.tcs_date
                        ? moment(profileData.tcs_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.tcs_date && (
                    <p className="error-message">{errors.tcs_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Aerial Rescue Certified</b>
            </span>
            <span>
              {(profileData.arc ? 'Qualified' : 'Not Qualified') +
                (profileData.arc && profileData.arc_date
                  ? ' on ' + formatDate(profileData.arc_date)
                  : '')}
            </span>
            <EditProfile
              label="Aerial Rescue Certified"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('arc', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.arc}
                    className={errors.arc && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.arc && (
                    <p className="error-message">{errors.arc.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="arc_date"
                    control={control}
                    defaultValue={
                      profileData.arc_date
                        ? moment(profileData.arc_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.arc_date && (
                    <p className="error-message">{errors.arc_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Aerial Liift Specialist - Compact</b>
            </span>
            <span>
              {(profileData.alsc ? 'Qualified' : 'Not Qualified') +
                (profileData.alsc && profileData.alsc_date
                  ? ' on ' + formatDate(profileData.alsc_date)
                  : '')}
            </span>
            <EditProfile
              label="Aerial Liift Specialist - Compact"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('alsc', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.alsc}
                    className={errors.alsc && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.alsc && (
                    <p className="error-message">{errors.alsc.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="alsc_date"
                    control={control}
                    defaultValue={
                      profileData.alsc_date
                        ? moment(profileData.alsc_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.alsc_date && (
                    <p className="error-message">{errors.alsc_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>SRT Climber</b>
            </span>
            <span>
              {(profileData.srt ? 'Qualified' : 'Not Qualified') +
                (profileData.srt && profileData.srt_date
                  ? ' on ' + formatDate(profileData.srt_date)
                  : '')}
            </span>
            <EditProfile
              label="SRT Climber"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('srt', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.srt}
                    className={errors.srt && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.srt && (
                    <p className="error-message">{errors.srt.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="srt_date"
                    control={control}
                    defaultValue={
                      profileData.srt_date
                        ? moment(profileData.srt_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.srt_date && (
                    <p className="error-message">{errors.srt_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Best Practices Crane Use</b>
            </span>
            <span>
              {(profileData.bpcu ? 'Qualified' : 'Not Qualified') +
                (profileData.bpcu && profileData.bpcu_date
                  ? ' on ' + formatDate(profileData.bpcu_date)
                  : '')}
            </span>
            <EditProfile
              label="Best Practices Crane Use"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('bpcu', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.bpcu}
                    className={errors.bpcu && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.bpcu && (
                    <p className="error-message">{errors.bpcu.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="bpcu_date"
                    control={control}
                    defaultValue={
                      profileData.bpcu_date
                        ? moment(profileData.bpcu_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.bpcu_date && (
                    <p className="error-message">{errors.bpcu_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Best Practices Rigging</b>
            </span>
            <span>
              {(profileData.bpr ? 'Qualified' : 'Not Qualified') +
                (profileData.bpr && profileData.bpr_date
                  ? ' on ' + formatDate(profileData.bpr_date)
                  : '')}
            </span>
            <EditProfile
              label="Best Practices Rigging"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('bpr', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.bpr}
                    className={errors.bpr && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.bpr && (
                    <p className="error-message">{errors.bpr.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="bpr_date"
                    control={control}
                    defaultValue={
                      profileData.bpr_date
                        ? moment(profileData.bpr_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.bpr_date && (
                    <p className="error-message">{errors.bpr_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>ISA Certified Arborist</b>
            </span>
            <span>
              {(profileData.isaca ? 'Qualified' : 'Not Qualified') +
                (profileData.isaca && profileData.isaca_date
                  ? ' on ' + formatDate(profileData.isaca_date)
                  : '')}
            </span>
            <EditProfile
              label="ISA Certified Arborist"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('isaca', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.isaca}
                    className={errors.isaca && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.isaca && (
                    <p className="error-message">{errors.isaca.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="isaca_date"
                    control={control}
                    defaultValue={
                      profileData.isaca_date
                        ? moment(profileData.isaca_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.isaca_date && (
                    <p className="error-message">{errors.isaca_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Certified Treecare Safety Professional</b>
            </span>
            <span>
              {(profileData.ctsp ? 'Qualified' : 'Not Qualified') +
                (profileData.ctsp && profileData.ctsp_date
                  ? ' on ' + formatDate(profileData.ctsp_date)
                  : '')}
            </span>
            <EditProfile
              label="Certified Treecare Safety Professional"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('ctsp', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.ctsp}
                    className={errors.ctsp && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.ctsp && (
                    <p className="error-message">{errors.ctsp.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="ctsp_date"
                    control={control}
                    defaultValue={
                      profileData.ctsp_date
                        ? moment(profileData.ctsp_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.ctsp_date && (
                    <p className="error-message">{errors.ctsp_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>ISA Tree Risk Assement Qualification</b>
            </span>
            <span>
              {(profileData.traq ? 'Qualified' : 'Not Qualified') +
                (profileData.traq && profileData.traq_date
                  ? ' on ' + formatDate(profileData.traq_date)
                  : '')}
            </span>
            <EditProfile
              label="ISA Tree Risk Assement Qualification"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('traq', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.traq}
                    className={errors.traq && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.traq && (
                    <p className="error-message">{errors.traq.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="traq_date"
                    control={control}
                    defaultValue={
                      profileData.traq_date
                        ? moment(profileData.traq_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.traq_date && (
                    <p className="error-message">{errors.traq_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>PHC technician</b>
            </span>
            <span>
              {(profileData.phct ? 'Qualified' : 'Not Qualified') +
                (profileData.phct && profileData.phct_date
                  ? ' on ' + formatDate(profileData.phct_date)
                  : '')}
            </span>
            <EditProfile
              label="PHC technician"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('phct', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.phct}
                    className={errors.phct && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.phct && (
                    <p className="error-message">{errors.phct.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="phct_date"
                    control={control}
                    defaultValue={
                      profileData.phct_date
                        ? moment(profileData.phct_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.phct_date && (
                    <p className="error-message">{errors.phct_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>First Aid and CPR</b>
            </span>
            <span>
              {(profileData.facpr ? 'Qualified' : 'Not Qualified') +
                (profileData.facpr && profileData.facpr_date
                  ? ' on ' + formatDate(profileData.facpr_date)
                  : '')}
            </span>
            <EditProfile
              label="First Aid and CPR"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('facpr', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.facpr}
                    className={errors.facpr && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.facpr && (
                    <p className="error-message">{errors.facpr.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="facpr_date"
                    control={control}
                    defaultValue={
                      profileData.facpr_date
                        ? moment(profileData.facpr_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.facpr_date && (
                    <p className="error-message">{errors.facpr_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Mechanic</b>
            </span>
            <span>
              {(profileData.mech ? 'Qualified' : 'Not Qualified') +
                (profileData.mech && profileData.mech_date
                  ? ' on ' + formatDate(profileData.mech_date)
                  : '')}
            </span>
            <EditProfile
              label="Mechanic"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('mech', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.mech}
                    className={errors.mech && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.mech && (
                    <p className="error-message">{errors.mech.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="mech_date"
                    control={control}
                    defaultValue={
                      profileData.mech_date
                        ? moment(profileData.mech_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.mech_date && (
                    <p className="error-message">{errors.mech_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Operations Position</b>
            </span>
            <span>
              {(profileData.ops ? 'Qualified' : 'Not Qualified') +
                (profileData.ops && profileData.ops_date
                  ? ' on ' + formatDate(profileData.ops_date)
                  : '')}
            </span>
            <EditProfile
              label="Operations Position"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('ops', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.ops}
                    className={errors.ops && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.ops && (
                    <p className="error-message">{errors.ops.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="ops_date"
                    control={control}
                    defaultValue={
                      profileData.ops_date
                        ? moment(profileData.ops_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.ops_date && (
                    <p className="error-message">{errors.ops_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
          <li role="listitem">
            <span>
              <b>Administrative Position</b>
            </span>
            <span>
              {(profileData.adm ? 'Qualified' : 'Not Qualified') +
                (profileData.adm && profileData.adm_date
                  ? ' on ' + formatDate(profileData.adm_date)
                  : '')}
            </span>
            <EditProfile
              label="Administrative Position"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('adm', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.adm}
                    className={errors.adm && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.adm && (
                    <p className="error-message">{errors.adm.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="adm_date"
                    control={control}
                    defaultValue={
                      profileData.adm_date
                        ? moment(profileData.adm_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.adm_date && (
                    <p className="error-message">{errors.adm_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>

          <li role="listitem">
            <span>
              <b>Other</b>
            </span>
            <span>
              {(profileData.ot ? 'Qualified' : 'Not Qualified') +
                (profileData.ot && profileData.ot_date
                  ? ' on ' + formatDate(profileData.ot_date)
                  : '')}
            </span>
            <EditProfile
              label="Other"
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={permList.includes(
                'Manage Qualifications'
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification Status</label>
                  <select
                    {...register('ot', {
                      required: 'Qualification status is required',
                    })}
                    defaultValue={profileData.ot}
                    className={errors.ot && 'profile-form-field-error'}
                  >
                    <option value="0">Not Qualified</option>
                    <option value="1">Qualified</option>
                  </select>
                  {errors.ot && (
                    <p className="error-message">{errors.ot.message}</p>
                  )}

                  <label>Qualifying Date</label>
                  <Controller
                    name="ot_date"
                    control={control}
                    defaultValue={
                      profileData.ot_date
                        ? moment(profileData.ot_date).format(
                            dateTimeConstants.DATE_FORMAT
                          )
                        : null
                    }
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : ''
                          )
                        }
                        customInput={<input inputMode="none" />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText="Select Qualifying Date"
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.ot_date && (
                    <p className="error-message">{errors.ot_date.message}</p>
                  )}
                </>
              )}
            </EditProfile>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default QualificationsComponent;
